<div class="lilate-list-wrapper">
    <div>
        <div class="list-title" translate>
            <span class="pending-count">{{lilatesPendingAssements.length}}</span> teacher.lilate.list.pending
        </div>
        <app-teacher-lilate *ngFor="let lilate of lilatesPendingAssements" [lilate]="lilate" (updateLilates)="updateLilates()" [assessment]="true">
        </app-teacher-lilate>
       <div *ngIf="nextPendingAssements" (click)="getLilatesPendingAssessments()" translate>
            teacher.lilate.list.load
       </div>
    </div>

    <div>
        <div class="list-title" translate>
            <span class="pending-count">{{lilatesUpcoming.length}}</span> teacher.lilate.list.pending-count <span *ngIf="last" class="planned-lastdate" translate [translateParams]="{dateuntil: last | amLocale: 'en' | amDateFormat:'LLL'}">teacher.lilate.list.until</span>
        </div>
        <app-teacher-lilate  *ngFor="let lilate of lilatesUpcoming" [lilate]="lilate" (updateLilates)="updateLilates()" [assessment]="false">
        </app-teacher-lilate>
        <div *ngIf="nextUpcoming" (click)="getLilatesUpcomings()" translate>
            teacher.lilate.list.load
        </div>
    </div>
</div>